import { render, staticRenderFns } from "./call-incoming-icon.vue?vue&type=template&id=4dd808fd"
import script from "./call-incoming-icon.vue?vue&type=script&lang=js"
export * from "./call-incoming-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4dd808fd')) {
      api.createRecord('4dd808fd', component.options)
    } else {
      api.reload('4dd808fd', component.options)
    }
    module.hot.accept("./call-incoming-icon.vue?vue&type=template&id=4dd808fd", function () {
      api.rerender('4dd808fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/notifications/call-incoming-icon.vue"
export default component.exports